import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Fab, useTheme, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const SCROLL_THRESHOLD = 300; // Show button after scrolling this many pixels

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = React.useState(false);
  const theme = useTheme();

  // Handle scroll events
  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > SCROLL_THRESHOLD);
    };

    // Add scroll event listener
    window.addEventListener('scroll', toggleVisibility);

    // Clean up
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Zoom in={isVisible}>
      <Fab
        onClick={scrollToTop}
        size="medium"
        aria-label="Scroll back to top"
        tabIndex={isVisible ? 0 : -1}
        sx={{
          position: 'fixed',
          bottom: theme.spacing(4),
          right: theme.spacing(4),
          borderRadius: '8px',
          zIndex: theme.zIndex.speedDial,
          '&:hover': {
            transform: 'scale(1.1)',
            transition: 'transform 0.2s'
          },
          '&:focus': {
            outline: `2px solid ${theme.palette.primary.main}`,
            outlineOffset: '2px'
          }
        }}
      >
        <KeyboardArrowUpIcon aria-hidden="true" />
      </Fab>
    </Zoom>
  );
};

export default ScrollToTop; 